import * as types from "./types";
import {
    getEmployeeAxios,
    deleteEmployeeAxios,
    postEmployeeAxios,
    putEmployeeAxios,
    getEmployeeByIdAxios,
    getEmployeeDocAxios,
    getEmployeeDocByIdAxios,
    postEmployeeDocAxios,
    putEmployeeDocAxios,
    deleteEmployeeDocAxios,
    getEmployeeIdDocAxios,
    downloadEmployeeDocAxios,

} from "./services";

//#region Employee

export async function getEmployeeListAction({ commit }) {
    commit(types.LOADING_EMPLOYEE, true);
    try {
        const { data } = await getEmployeeAxios();
        commit(types.GET_EMPLOYEE_LIST, data.result.data);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE, false);
    }
}

export async function removeEmployeeAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE, true);
    try {
        await deleteEmployeeAxios(payload);
        commit(types.REMOVE_EMPLOYEE, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE, false);
    }
}

export async function addEmployeeAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE, true);
    try {
        const { data } = await postEmployeeAxios(payload);
        commit(types.ADD_EMPLOYEE, payload);
        return data;
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE, false);
    }
}

export async function updateEmployeeAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE, true);
    try {
        const { data } = await putEmployeeAxios(payload);
        commit(types.UPDATE_EMPLOYEE, payload);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE, false);
    }
}

export async function getEmployeeByIdAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE, true);
    try {
        const { data } = await getEmployeeByIdAxios(payload);
        commit(types.GET_EMPLOYEEID, data.result);

    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE, false);
    }
}

//#endregion

//#region Document

export async function getEmployeeDocAction({ commit }) {
    commit(types.LOADING_EMPLOYEE_DOC, true);
    try {
        const { data } = await getEmployeeDocAxios();
        commit(types.GET_EMPLOYEE_LIST_DOC, data.result.data);
        console.log("🚀 ~ getEmployeeDocAction ~ data.result.data:", data.result.data);
        return data.result.data;
    }
        
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE_DOC, false);
    }
}
export async function getEmployeeIdDocAction({ commit }, id) {
    commit(types.LOADING_EMPLOYEE_DOC, true);
    try {

        const { data } = await getEmployeeIdDocAxios(id);
        commit(types.GET_EMPLOYEE_LIST_DOC, data.result.data);
        return data.result.data;
    }
        
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE_DOC, false);
    }
}

export async function removeEmployeeDocAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE_DOC, true);
    try {
        await deleteEmployeeDocAxios(payload);
        commit(types.REMOVE_EMPLOYEE_DOC, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE_DOC, false);
    }
}

export async function addEmployeeDocAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE_DOC, true);
    try {
        const { data } = await postEmployeeDocAxios(payload);
        commit(types.ADD_EMPLOYEE_DOC, payload);
        return data;
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE_DOC, false);
    }
}

export async function updateEmployeeDocAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE_DOC, true);
    try {
        const { data } = await putEmployeeDocAxios(payload);
        commit(types.UPDATE_EMPLOYEE_DOC, payload);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE_DOC, false);
    }
}

export async function getEmployeeDocByIdAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE_DOC, true);
    try {
        const { data } = await getEmployeeDocByIdAxios(payload);
        commit(types.GET_EMPLOYEEID_DOC, data.result);

    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE_DOC, false);
    }
}

export async function downloadEmployeeDocAction({ commit }, payload) {
    commit(types.LOADING_EMPLOYEE_DOC, true);
    try {
        var result = await downloadEmployeeDocAxios(payload);
        console.log("🚀 ~ downloadEmployeeDocAction ~ result:", result)
        return result;
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_EMPLOYEE_DOC, false);
    }
}

//#endregion